import { render, staticRenderFns } from "./MenuPulpit.vue?vue&type=template&id=26890a90&scoped=true&"
import script from "./MenuPulpit.vue?vue&type=script&lang=js&"
export * from "./MenuPulpit.vue?vue&type=script&lang=js&"
import style0 from "./MenuPulpit.vue?vue&type=style&index=0&id=26890a90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26890a90",
  null
  
)

export default component.exports